<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb wrapper" @click="handelGoHome">
      首页 > {{ meetingName }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'
export default defineComponent({
  props: {
    meetingName: String
  },
  setup() {
    const router: Router = useRouter()
    const route: RouteLocationNormalizedLoaded = useRoute()
    const handelGoHome = () => {
      if (route.name !== 'home') {
        router.go(-1)
      }
    }
    return {
      handelGoHome
    }
  }
})
</script>

<style scoped lang="scss">
.breadcrumb-container {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #fafafa;
  color: #333;
  font-size: 14px;
  .breadcrumb {
    box-sizing: border-box;
    padding-left: 45px;
    position: relative;
    cursor: pointer;
    font-weight: 500;
    color: #333;
    &::after {
      position: absolute;
      top: 6px;
      left: 0;
      content: '';
      display: block;
      width: 26px;
      height: 26px;
      background: url('../../assets/images/layout/home.png') no-repeat center;
    }
  }
}
</style>
